import { NavItem } from '@/types/navigation';
import { pushGtmEvent } from '@/utils/gtm';
import classnames from 'classnames';
import Link from 'next/link';
import React from 'react';

import styles from './FooterItem.module.scss';

export type FooterItemProps = {
  name: string;
  href: string;
  subItems?: NavItem[];
  passHref?: boolean;
};

const trackFooterLinkClick = (item: NavItem) => {
  pushGtmEvent({
    event: 'footer_link_click',
    element: 'Footer Sub Link',
    link_text: item.label,
    link_url: item.to,
  });
};

const FooterItem = ({ name, href, subItems, passHref }: FooterItemProps) => (
  <>
    <Link prefetch={false} passHref={passHref} href={href} as={href} className={styles.link}>
      {name}
    </Link>
    {subItems
      ? subItems.map(item => (
          <Link
            key={item.label as string}
            prefetch={false}
            href={item.to}
            as={item.to}
            passHref
            className={classnames(styles.link, styles.subLink)}
            onClick={() => trackFooterLinkClick(item)}
          >
            {item.label}
          </Link>
        ))
      : null}
  </>
);

export default FooterItem;
